export default __webpack_public_path__ + "static/benefitImage5-c2ed133efd8b047dc273c19cd577f688.webp";